import { render, staticRenderFns } from "./FederationSidebarNavigation.vue?vue&type=template&id=2ebb0686&scoped=true"
import script from "./FederationSidebarNavigation.vue?vue&type=script&lang=ts"
export * from "./FederationSidebarNavigation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebb0686",
  null
  
)

export default component.exports